import { Trans } from '@lingui/react';
import clsx from 'clsx';
import globalStyles from 'styles/globalStyles';

export const ProductTitle = ({
  title,
  isLoading,
  className,
  isSticky,
}: {
  title: string;
  isLoading: boolean;
  className?: string;
  isSticky?: boolean;
}) => {
  // For SEO, title should only be h1 when within the main product form.
  const CustomTag: React.ElementType = isSticky
    ? ('span' as keyof JSX.IntrinsicElements)
    : ('h1' as keyof JSX.IntrinsicElements);

  return (
    <CustomTag
      className={clsx(
        'text-heading-h5-mobile text-heading-h5-desktop',
        className
      )}
      data-test-id="productTitle"
    >
      {isLoading && (
        <span
          className={[
            globalStyles.isLoading,
            globalStyles['isLoading--inline'],
          ].join(' ')}
        >
          <Trans id="accessibility.loading" message="Loading..." />
        </span>
      )}
      {!isLoading && title}
    </CustomTag>
  );
};
